// libraries
import React from "react";
import { useSelector } from "react-redux";
// hooks & context
import { useALDOTMessageData } from "./hooks";
// styles
import * as SC from "./Styled";
// components

export type IProps = {
    
};

export const ALDOTMessages: React.FC<IProps> = (props) => {

    useALDOTMessageData();
    const aldotMessageStore: any = useSelector( (state: any) => state["aldot-message"]);
    const messages: any = aldotMessageStore.videoData;

    if (!messages || messages < 1) return null;

    return (
        <SC.Container>
            {messages?.map(
                (message: any, index: number) => {
                    return (
                        <SC.MessageWrapper key={index}>
                            <SC.Title>{message.title}</SC.Title>
                            <SC.Message>{message.body}</SC.Message>
                        </SC.MessageWrapper>
                    );
                }
            )}
        </SC.Container>
        
    );
};

export default ALDOTMessages;